(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('tfcLoadingPane', tfcLoadingPane);

  // @ngInject
  function tfcLoadingPane($compile) {
    return {
      restrict: 'A',
      link: getLinkFunction($compile)
    };
  }

  function getLinkFunction($compile) {
    return function link(scope, element, attrs) {
      if (attrs.tfcLoadingPane === '') {
        throw new Error('show-when-loaded expects an expression that evaluates to a boolean');
      }

      // NOTE: HTML snippet for loading indicator
      var loadingIndicator = $compile(
          '<div class="loading-indicator"></div>'
      )(scope);

      element.addClass('hide');
      element.after(loadingIndicator);

      scope.$watch(attrs.tfcLoadingPane, function(result) {
        if (result === true) {
          loadingIndicator.remove();
          element.removeClass('hide');
        } else {
          element.addClass('hide');
          element.after(loadingIndicator);
        }
      });
    };
  }
})();